// extracted by mini-css-extract-plugin
export default {"pricing-summary":"pgiiQ","container":"fqxu7"};